<div class="header-logo"
    [ngClass]="{ 'hide-on-small-screen': hideOnSmallScreen, 'enforce-flexportal-theme': enforceFlexportalTheme }">
    <div>
        <img *ngIf="logoUrl" [src]="logoUrl" />
    </div>
</div>
